import React, { useState } from 'react';
import { useField, FieldAttributes, ErrorMessage } from 'formik';
import classNames from 'classnames';
import Icon_Eye_Open from 'assets/apply.clevry/Icon_Form_Password.png';
import Icon_Eye_Closed from 'assets/apply.clevry/Icon_Form_Password_02.png';

const ErrorM: React.FC<{ name: string }> = (props) => (
  <ErrorMessage name={props.name}>
    {(msg) => <div className="ErrorLabel">{msg}</div>}
  </ErrorMessage>
);

function FieldInput<T>(
  props: FieldAttributes<T> & { placeholder: string; label: string, togglePasswordView?: boolean }
) {
  const { placeholder, ...fieldProps } = props;

  const [isFocused, setIsFocused] = useState(false);
    const [togglePassword, setTogglePassword] = useState<boolean>(false);

  const [field, { touched, error }] = useField(
    fieldProps as FieldAttributes<T>
  );
  const showError = touched && error;
  const errorText = error && touched ? error : '';

  const { className: existingClasses, ...rest } = props;
  const className = classNames(existingClasses, {
    ErrorInput: showError,
  });

  const errorInputClassName = `${errorText ? 'Error' : ''}`;
  const labelStyle = `${isFocused ? 'Focused' : ''} ${
    errorText && !isFocused ? 'Error' : ''
  }`;

  const onFocus = () => setIsFocused(true);
  const onBlur = () => setIsFocused(false);

  return (
    <React.Fragment>
      <div className="FormLabel">
        <label className={labelStyle}>{props.label}</label>
      </div>
      <div className="FormField" style={{position : 'relative'}}>
        <input
          {...(field as any)}
          {...rest}
          className={`${className} ${errorInputClassName}`}
          placeholder={placeholder}
          onFocus={onFocus}
          onBlur={onBlur}
          type={
            props.type === 'password' && togglePassword
              ? 'text'
              : props.type
          }
        />
        {props.type === 'password' && props.togglePasswordView ? (
          <img
            style={{
              position: 'absolute',
              cursor: 'pointer',
              top: '0',
              right: '0',
              height: '40px',
            }}
            src={togglePassword ? Icon_Eye_Open : Icon_Eye_Closed}
            alt="toggle password"
            className="TogglePassword"
            onClick={() => {
              setTogglePassword(!togglePassword);
            }}
          />
        ) : null}
        <ErrorM name={props.name} />
      </div>
    </React.Fragment>
  );
}

export default FieldInput;
